import { Checkbox, FormControlLabel, withStyles, WithStyles, Theme, Grid } from '@material-ui/core'
import i18next from 'i18next'

const styles = (theme: Theme) => ({
  container: {
    boxSizing: 'border-box' as const,
    width: '100%',
    padding: '0px',
    marginTop: '16px',
    background: 'transparent',
  },
  checkboxGrid: {
    width: '100%',
    margin: 0,
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'row' as const,
      flexWrap: 'wrap' as const,
      justifyContent: 'flex-start' as const,
    },
  },
  checkboxItem: {
    [theme.breakpoints.down('xs')]: {
      width: '50%',
      minWidth: 0,
      margin: 0,
      padding: 0,
    },
    width: '20%',
    minWidth: 0,
    margin: 0,
    padding: 0,
  },
})

interface ApplicationsTabsProps extends WithStyles {
  filterState: {
    creditStatusGood: boolean,
    guarantorPossible: boolean,
    petsNo: boolean,
    livelihoodPermanentJob: boolean,
    lifeSituationWorking: boolean,
    lifeSituationPension: boolean,
    lifeSituationStudent: boolean,
    movingWithAlone: boolean,
    movingWithCouple: boolean,
    depositPaymentMoney: boolean,
    rejected: boolean
  },
  setFilterState: React.Dispatch<React.SetStateAction<{
    creditStatusGood: boolean,
    guarantorPossible: boolean,
    petsNo: boolean,
    livelihoodPermanentJob: boolean,
    lifeSituationWorking: boolean,
    lifeSituationPension: boolean,
    lifeSituationStudent: boolean,
    movingWithAlone: boolean,
    movingWithCouple: boolean,
    depositPaymentMoney: boolean,
    rejected: boolean
  }>>,
  t: i18next.TFunction
  isAdmin: boolean
}

const ApplicationsTabs = ({
  filterState,
  setFilterState,
  t,
  classes,
  isAdmin
}: ApplicationsTabsProps) => {
  const isFi = (i18next.language || '').split('-')[0] === 'fi'
  return (
    <div className={classes.container}>
      <Grid container spacing={0} className={classes.checkboxGrid}>
        <Grid item className={classes.checkboxItem}>
          <FormControlLabel
            control={
              <Checkbox
                checked={filterState.creditStatusGood}
                onChange={(_, checked) => setFilterState(s => ({ ...s, creditStatusGood: checked }))}
                color="primary"
              />
            }
            label={isFi ? 'Luottotiedot OK' : 'Credit status OK'}
          />
        </Grid>
        <Grid item className={classes.checkboxItem}>
          <FormControlLabel
            control={
              <Checkbox
                checked={filterState.guarantorPossible}
                onChange={(_, checked) => setFilterState(s => ({ ...s, guarantorPossible: checked }))}
                color="primary"
              />
            }
            label={isFi ? 'Henkilötakaus' : 'Guarantor'}
          />
        </Grid>
        <Grid item className={classes.checkboxItem}>
          <FormControlLabel
            control={
              <Checkbox
                checked={filterState.petsNo}
                onChange={(_, checked) => setFilterState(s => ({ ...s, petsNo: checked }))}
                color="primary"
              />
            }
            label={isFi ? 'Ei lemmikkejä' : 'No pets'}
          />
        </Grid>
        <Grid item className={classes.checkboxItem}>
          <FormControlLabel
            control={
              <Checkbox
                checked={filterState.livelihoodPermanentJob}
                onChange={(_, checked) => setFilterState(s => ({ ...s, livelihoodPermanentJob: checked }))}
                color="primary"
              />
            }
            label={isFi ? 'Vakituinen työ' : 'Permanent job'}
          />
        </Grid>
        <Grid item className={classes.checkboxItem}>
          <FormControlLabel
            control={
              <Checkbox
                checked={filterState.lifeSituationWorking}
                onChange={(_, checked) => setFilterState(s => ({ ...s, lifeSituationWorking: checked }))}
                color="primary"
              />
            }
            label={isFi ? 'Työssäkäyvä' : 'Employed'}
          />
        </Grid>
        <Grid item className={classes.checkboxItem}>
          <FormControlLabel
            control={
              <Checkbox
                checked={filterState.lifeSituationPension}
                onChange={(_, checked) => setFilterState(s => ({ ...s, lifeSituationPension: checked }))}
                color="primary"
              />
            }
            label={isFi ? 'Eläkkeellä' : 'Retired'}
          />
        </Grid>
        <Grid item className={classes.checkboxItem}>
          <FormControlLabel
            control={
              <Checkbox
                checked={filterState.lifeSituationStudent}
                onChange={(_, checked) => setFilterState(s => ({ ...s, lifeSituationStudent: checked }))}
                color="primary"
              />
            }
            label={isFi ? 'Opiskelija' : 'Student'}
          />
        </Grid>
        <Grid item className={classes.checkboxItem}>
          <FormControlLabel
            control={
              <Checkbox
                checked={filterState.movingWithAlone}
                onChange={(_, checked) => setFilterState(s => ({ ...s, movingWithAlone: checked }))}
                color="primary"
              />
            }
            label={isFi ? 'Yksinasuva' : 'Living alone'}
          />
        </Grid>
        <Grid item className={classes.checkboxItem}>
          <FormControlLabel
            control={
              <Checkbox
                checked={filterState.movingWithCouple}
                onChange={(_, checked) => setFilterState(s => ({ ...s, movingWithCouple: checked }))}
                color="primary"
              />
            }
            label={isFi ? 'Pariskuntana' : 'As a couple'}
          />
        </Grid>
        <Grid item className={classes.checkboxItem}>
          <FormControlLabel
            control={
              <Checkbox
                checked={filterState.depositPaymentMoney}
                onChange={(_, checked) => setFilterState(s => ({ ...s, depositPaymentMoney: checked }))}
                color="primary"
              />
            }
            label={isFi ? 'Vakuus rahalla' : 'Money deposit'}
          />
        </Grid>
        {isAdmin && (
          <Grid item className={classes.checkboxItem}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={filterState.rejected}
                  onChange={(_, checked) => setFilterState(s => ({ ...s, rejected: checked }))}
                  color="primary"
                />
              }
              label={t('applications.tabs.rejected', 'Ohitetut')}
            />
          </Grid>
        )}
      </Grid>
    </div>
  )
}

export default withStyles(styles)(ApplicationsTabs)

